import React, { useEffect, useState } from 'react';
import {useNavigate, Link} from "react-router-dom";

import { useTranslation, Trans } from 'react-i18next';
import Popup from 'reactjs-popup';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Accordion, Button} from 'react-bootstrap';



import "../styles/home.scss"


function Home(props){
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(1);
    const [popupOpen, setPopupOpen] = useState(false);
    const [dataCleared, setDataCleared] = useState(false);
    let history = useNavigate();



    const toggle = (e,i) => {
        //console.log(i)
        let a = i === isOpen ? "" : i
        setIsOpen(a)

    };

    const openModal = () => {
        setPopupOpen(true);
    }
    const closeModal = () => {
        setPopupOpen(false)
    }

    const clearData = () => {
        localStorage.clear()
        setDataCleared(true)
    }

    const deathLink = () => {
        localStorage.setItem('isDead', true);
        history('information')
    }
    const injuredLink = () => {
        localStorage.setItem('isDead', false);
        history('information')
    }

    return (

        <div className={"container"}>
            {popupOpen &&
                <Popup
                    open={popupOpen}
                    closeOnDocumentClick
                    onClose={closeModal}
                >
                    <div className={
                        "modal-content"
                    }>
                        <div className={"modal-header"}>
                            <a className="close" onClick={closeModal}>
                                &times;
                            </a>
                        </div>
                        {!dataCleared &&

                            <div className="modal-body">
                                <Trans i18nKey={"ClearData"}>
                                    <p>Etes-vous sûr de vouloir effacer les données remplies et que votre navigateur a
                                        enregistré?</p>
                                </Trans>
                            </div>
                        }
                        {!dataCleared &&
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary danger small" onClick={closeModal}>{i18n.t('no')}</button>
                                <button onClick={clearData}
                                        className="btn btn-danger btn-ok">{i18n.t('yes')}</button>
                            </div>
                        }
                        {!!dataCleared &&
                            <div className="modal-body">
                                <Trans i18nKey={"Les données ont été effacées"}>
                                    <p>Les données de vos formulaires sont effacées.</p>
                                </Trans>
                            </div>

                        }

                    </div>
                </Popup>
            }
            <div>
                <Trans i18nKey="0HomeTITLE" ><h1>Questionnaire après <span>un accident</span> avec dommages corporels</h1></Trans>
                <div className="row mb-4">
                    <div className={'col-md-8 offset-md-2 text-center'}>
                        <FontAwesomeIcon icon={['fas', 'house']} />
                        <Trans i18nKey="0Homeintro" >
                            <p>Après un accident ayant entraîné des dommages corporels ou un décès, vous devez souvent faire face à un tas d’actes administratifs à la demande de différents assureurs en vue d’obtenir une indemnisation. </p>
                            <p>Afin de simplifier ces démarches et de ne devoir les effectuer qu’une seule fois, vous pouvez faire usage d’un questionnaire interactif qui peut ensuite être transmis aux assureurs concernés. </p>
                        </Trans>
                    </div>
                </div>
                <h3>{i18n.t("Comment ça marche ?")}</h3>
                <div className="row mb-4">
                    <div className="col-6">
                        <div className="bg-light-secondary">
                        <h4>{i18n.t("Si vous avez vous-même subi des dommages corporels,")}<br/> </h4>
                        <Button className={"btn-outline small"} onClick={injuredLink}>{i18n.t("cliquez ici")}<FontAwesomeIcon icon={['fas', 'arrow-right']} /></Button>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="bg-light-ass">
                        <h4>{i18n.t("Si vous avez perdu un proche,")}<br/> </h4>
                        <Button className={"btn-outline small"} onClick={deathLink}>{i18n.t("cliquez ici")} <FontAwesomeIcon icon={['fas', 'arrow-right']} /></Button>
                        </div>
                    </div>
                </div>

                <div className={"text-left mb-4"}>
                    <h2>{i18n.t("Quelle est la finalité de ce questionnaire ?")}</h2>
                    <Trans i18nKey="0HomewhyUse" >
                        <p>L'objectif est que vous établissiez un document pdf facilement lisible reprenant des données importantes pour le ou les assureurs concernés dans votre accident. Vous devez conserver vous-même ce document sur votre ordinateur et l’envoyer, signé, à l'assureur qui vous a demandé de compléter ce questionnaire.</p>
                        <p>Après un accident, vous devez en effet souvent transmettre des informations aux assureurs impliqués. Cela peut être votre propre assureur, mais aussi celui d'une autre partie impliquée. En tant que victime d'un accident, il est possible que même plusieurs assureurs vous en fassent la demande, alors que les informations dont ils ont besoin sont les mêmes.</p>
                        <p>C'est pourquoi les assureurs de responsabilité et les assureurs de protection juridique membres d'Assuralia ont conçu un questionnaire uniforme. Celui-ci existait déjà auparavant sur papier (cf. au bas de cette page). Mais afin de faciliter le remplissage et d'éviter des questions qui ne s'appliquent de toute façon pas à votre situation, Assuralia, l'union professionnelle des entreprises d'assurances, propose ici une variante interactive.</p>
                    </Trans>
                </div>

                <Accordion id="myAccordion" activeKey={isOpen} defaultActiveKey={isOpen} onSelect={(e)=> toggle({ e : isOpen})}>
                    <Accordion.Item id={1} eventKey={1} >
                        <Accordion.Header onClick={e => toggle(e,1)}><h4> {i18n.t("Comment ça marche ?")}</h4>
                        </Accordion.Header>
                        <Accordion.Body>
                            <ol start="1" type="1">
                                <Trans i18nKey="0HomehowItWorksList" >
                                    <li>Vous-même ou l'un de vos proches avez été victime d'un accident et vous devez déclarer l'accident auprès de votre assureur de protection juridique, de votre assureur de responsabilité ou de l'assureur d'un responsable. Vous avez reçu à cette fin un message de cet assureur.
                                    </li>
                                    <li>Gardez les <strong><a role='button' onClick={e=>toggle(e,2)}>documents nécessaires sous la main</a></strong> afin de pouvoir compléter aisément le questionnaire.
                                    </li>
                                    <li>Remplissez le questionnaire de la manière la plus complète possible. Les champs obligatoires sont indiqués par un astérisque. Les données complétées ne sont pas enregistrées a fin de pouvoir garantir la protection de votre vie privée. Cela signifie donc que vous devez compléter le questionnaire en une fois. Si vous avez toutes les données sous la main, compléter le questionnaire vous prendra peut-être 20 à 30 minutes. Une session est ouverte pour deux heures. Un message vous avertira de l'expiration de la session. Un simple clic à ce moment-là vous permettra de la prolonger si nécessaire.
                                    </li>
                                    <li>Il est possible de revenir à une rubrique précédente du questionnaire, même si vous avez cliqué sur &quot;enregistrer et continuer&quot;. Pour naviguer dans le questionnaire, vous pouvez utiliser les boutons &quot;précédent&quot; et &quot;suivant&quot; à chaque page ou les onglets de chacune des rubriques en haut de l'écran.
                                    </li>
                                    <li>Lorsque vous avez complété toutes les données, vous recevez un résumé sous forme d'un document pdf. <strong>Conservez soigneusement le document pdf dans votre ordinateur </strong>. Les données complétées ne sont pas enregistrées par l'application. <button className={'btn p-0 btn-link'} onClick={openModal} >Afin de les effacer toutes du formulaire, cliquez ici</button>.
                                    </li>
                                    <li>Relisez et signez ce document, soit en l'imprimant et en le signant manuellement, soit en utilisant votre carte d'identité électronique et un lecteur de carte. Le questionnaire n'est valable que s'il est signé.
                                    </li>
                                    <li>Envoyez ensuite le document signé, par mail ou par la poste, à l'assureur qui vous a demandé de déclarer l'accident ou qui vous a interrogé pour obtenir des renseignements généraux.
                                    </li>
                                </Trans>
                            </ol>
                            <p>{i18n.t("Si un autre assureur de responsabilité ou un assureur de protection juridique demande les mêmes renseignements, vous ne devez pas compléter à nouveau le questionnaire, mais vous pouvez envoyer une copie du document conservé, après l'avoir signé, en indiquant quel(s) assureur(s) a (ont) déjà reçu ce document et en mentionnant le numéro de référence de son (leur) dossier.")}</p>

                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item id={2} eventKey={2} >
                        <Accordion.Header onClick={e => toggle(e,2)}><h4> {i18n.t("Quels documents et quelles données est-il préférable de garder sous la main ?")}</h4></Accordion.Header>
                        <Accordion.Body>
                            <div>
                                <ul type="disc">
                                    <Trans i18nKey="0HomelistDocs1" >
                                        <li>Le courrier par lequel un assureur vous demande de lui communiquer des renseignements généraux à la suite d'un accident, avec son numéro de référence.
                                        </li>
                                        <li>Vos données d'identité. S'il s'agit d'un proche décédé, vous avez également besoin de données de la victime.
                                        </li>
                                        <li>Votre numéro de compte bancaire.</li>
                                        <li>Des données sur l'accident proprement dit, des témoins éventuels, etc.</li>
                                    </Trans>
                                </ul>
                                <p>{i18n.t("Si d'application")} :</p>
                                <ul type="disc">
                                    <Trans i18nKey="0HomelistDocs2" >
                                        <li>Des données relatives à votre salaire ou au salaire du proche décédé telles qu'une fiche de paie (pour les salariés) ou l’avertissement-extrait de rôle des trois dernières années (pour les indépendants).
                                        </li>
                                        <li>Le certificat médical du médecin traitant.</li>
                                        <li>Les données émanant d'instances (mutualité, CPAS ou autres) ou d'assureurs auxquels vous avez déjà demandé une intervention dans le cadre de l'accident.
                                        </li>
                                        <li>Les données de l'assureur accidents du travail ou de l'assureur scolaire en cas d'accident du travail ou d'accident à l'école ou sur le chemin du travail ou de l'école.
                                        </li>
                                        <li>Votre carte d'identité électronique et un lecteur de carte. Vous devrez également saisir votre code pin.
                                        </li>
                                    </Trans>
                                </ul>
                            </div>

                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item id={3} eventKey={3} >
                        <Accordion.Header onClick={e => toggle(e,3)}><h4>{i18n.t(" Documents à télécharger")}
                        </h4></Accordion.Header>
                        <Accordion.Body>
                            <div>
                                <Trans i18nKey="0HomedocsIntro" >
                                    <p>Afin de faciliter la procédure d'indemnisation des victimes, les assureurs de responsabilité civile et les assureurs de protection juridique membres d’Assuralia ont établi une série de documents standard à compléter, destinés à la victime de dommages corporels à la suite d'un accident, ou en cas de décès d'un proche dans un accident. Ces documents peuvent être facilement téléchargés via les liens ci-dessous.</p>
                                    <p>La victime ne doit remplir le questionnaire et les documents qu’une seule fois. Si elle reçoit le même document ou formulaire d’un autre assureur impliqué, elle peut simplement lui envoyer une copie ou indiquer quel assureur dispose déjà du document complété en mentionnant le numéro de référence de son dossier.</p>
                                    <p>Pour les assureurs, ces documents standard présentent l’avantage d’identifier rapidement les informations nécessaires à la gestion de leurs dossiers.</p>
                                </Trans>
                                <ul type="disc">
                                    <li >
                                        <Trans i18nKey="0Homelink1Telechargement" >
                                            <a href={'//'+i18n.t('www.assuralia.be/images/docs/publicaties_publications/documents-standards-typedocumenten/annexe5.pdf')} target='_blank' rel='noopener noreferrer'>Certificat médical à remplir par le médecin</a>
                                        </Trans>
                                    </li>
                                    <li>
                                        <Trans i18nKey="0Homelink2Telechargement" >
                                            <a href={'//'+i18n.t('www.assuralia.be/images/docs/publicaties_publications/documents-standards-typedocumenten/annexe6.pdf')} target='_blank' rel='noopener noreferrer'>Attestation de frais médicaux à remplir par le médecin et la mutualité</a>
                                        </Trans>
                                    </li>
                                    <li>
                                        <Trans i18nKey="0Homelink3Telechargement" >
                                            <a href={'//'+i18n.t('www.assuralia.be/images/docs/publicaties_publications/documents-standards-typedocumenten/annexe7.pdf')} target='_blank' rel='noopener noreferrer'>Relevé des frais médicaux</a>
                                        </Trans>
                                    </li>
                                    <li>
                                        <Trans i18nKey="0Homelink4Telechargement" >
                                            <a href={'//'+i18n.t('www.assuralia.be/images/docs/publicaties_publications/documents-standards-typedocumenten/annexe8.pdf')} target='_blank' rel='noopener noreferrer'>Attestation de perte de revenu employeur</a>
                                        </Trans>
                                    </li>
                                    <li>
                                        <Trans i18nKey="0Homelink5Telechargement" >
                                            <a href={'//'+i18n.t('www.assuralia.be/images/docs/publicaties_publications/documents-standards-typedocumenten/annexe9.pdf')} target='_blank' rel='noopener noreferrer'>Attestation frais de déplacement et de parking</a>
                                        </Trans>
                                    </li>
                                </ul>
                            </div>

                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item id={4} eventKey={4} >
                        <Accordion.Header onClick={e => toggle(e,4)}><h4>{i18n.t(" Quid si mes données complétées ne sont pas correctes ou incomplètes\u00A0?")}</h4></Accordion.Header>
                        <Accordion.Body>
                            <div>
                                <Trans i18nKey="0HomewrongData" >
                                    <p>Il s’agit ici d’un premier échange important de données. Afin de faciliter la procédure d’indemnisation, vous êtes invité à être aussi précis et complet que possible, même si vous avez encore la possibilité de corriger ou compléter ces données par la suite. Dès que vous êtes en possession de l’information nécessaire, pensez également à mettre en ordre ces informations le plus vite possible.</p>
                                    <p>Certains champs à compléter sont toutefois obligatoires et vous empêcheront de progresser dans le questionnaire si vous ne les remplissez pas. Les champs non obligatoires sont également importants, mais l'assureur comprendra très bien si vous ne connaissez pas (encore) certains détails. </p>
                                    <p>Vérifiez tranquillement au passage et à la fin tout ce que vous avez complété et n'hésitez pas à prendre contact avec votre assureur ou votre intermédiaire au cas où vous auriez besoin d'aide.</p>
                                </Trans>
                            </div>

                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item id={5} eventKey={5} >
                        <Accordion.Header onClick={e => toggle(e,5)}><h4> {i18n.t("Pourquoi dois-je communiquer autant de détails ?")}</h4></Accordion.Header>
                        <Accordion.Body>
                            <div>
                                <Trans i18nKey="0HomewhyDetails" >
                                    <p>Certaines questions peuvent sembler aller loin. Lorsqu'un assureur doit estimer le montant de l'indemnisation qu'il sera sans doute amené à payer, il souhaite bien sûr le faire sur la base des données les plus correctes possibles. Une indemnisation correcte est en effet dans l'intérêt de tous.</p>
                                    <p>Les assureurs respectent évidemment toutes les règles légales relatives à la protection de vos données. Vous ne devez donc pas craindre une utilisation abusive de vos données à caractère personnel ou une atteinte à votre vie privée.</p>
                                    <p>Prenez contact avec votre assureur ou votre intermédiaire si vous désirez savoir pourquoi certaines données peuvent être importantes.</p>
                                </Trans>
                            </div>

                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item id={6} eventKey={6} >
                        <Accordion.Header onClick={e => toggle(e,6)}><h4> {i18n.t("Un problème technique ou une question ?")}</h4></Accordion.Header>
                        <Accordion.Body>
                            <div>
                                <Trans i18nKey="0Hometechnical" >
                                    <p>Vous ne savez pas comment vous devez répondre à une question ou vous ne disposez pas des données exactes ? Pour des questions portant sur le contenu du formulaire, le mieux est de prendre contact avec votre assureur ou l'assureur qui vous a demandé de compléter le questionnaire.</p>
                                    <p>Pour des questions d'ordre technique sur le fonctionnement du site Web, il vous est loisible de prendre contact avec Assuralia, l'union professionnelle des entreprises d'assurances, à l'aide du <a href={'//'+i18n.t('www.assuralia.be/fr/contact')} target='_blank' rel='noopener noreferrer'>formulaire de contact disponible sur le site Web d'Assuralia </a>.</p>
                                    <p>Au cas où vous ne parviendriez pas à signer le document au moyen de la carte d'identité électronique, vous trouverez davantage d'informations sur <a href='//eid.belgium.be/' target='_blank' rel='noopener noreferrer'>//eid.belgium.be/</a>. Si vous rencontrez malgré tout toujours des problèmes pour la signature électronique, il vous est toujours possible d'imprimer le document pdf et d'y apposer manuellement votre signature. Conservez dans ce cas aussi le document non signé dans votre ordinateur.</p>
                                </Trans>
                            </div>

                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item id={7} eventKey={7} >
                        <Accordion.Header onClick={e => toggle(e,7)}><h4> {i18n.t("Vie privée")}</h4>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div>
                                <Trans i18nKey="0Homeprivacy" >
                                    <p>En qualité de responsable du traitement, Assuralia met tout en œuvre pour traiter vos données à caractère personnel de manière sûre et intègre, et cela en conformité avec la réglementation en vigueur en matière de vie privée, et plus particulièrement avec le RGPD (Règlement général sur la protection des données - Règlement EU n° 2016/679 du 27 avril 2016) pour les traitements afférents à ce site internet.</p>
                                    <p>Les données complétées dans le formulaire ne sont pas enregistrées (ni sauvegardées) lorsque vous quitter ce site internet (que vous ayez ou non terminé de compléter entièrement le formulaire).</p>
                                    <p>Vous pouvez obtenir tous les détails relatifs à notre politique Vie Privée sur le site <a href={'//'+i18n.t("PRIVACY-NOTICE")} target='_blank' rel='noopener noreferrer'>www.assuralia.be/images/docs/privacy/privacy-notice-nl.pdf</a></p>
                                </Trans>
                            </div>

                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <div className={"my-4 text-center"}>
                    <Trans i18nKey="0HomenoNeed" >
                        <p>Vous préférez malgré tout compléter une version papier du questionnaire ? Le questionnaire papier <a href={'//'+i18n.t('www.assuralia.be/images/docs/publicaties_publications/documents-standards-typedocumenten/annexe2.pdf')} target='_blank' rel='noopener noreferrer'>en cas d'accident ayant entraîné des blessures</a> ou <a href={'//'+i18n.t('www.assuralia.be/images/docs/publicaties_publications/documents-standards-typedocumenten/annexe4.pdf')} target='_blank' rel='noopener noreferrer'>en cas d'accident mortel</a> peut être utilisé.</p>
                    </Trans>
                </div>
                <div className="footer">
                </div>
            </div>
        </div>
    );

}

export default Home;
